import React from "react";
import Collapsable from "../custom/Collapsable";
import Box from "@material-ui/core/Box";
// import ScheduleFilter from "./ScheduleFilter";
import Schedules from "./Schedules";
import useSchedules from "components/hooks/useSchedules";

const ScheduleContainer: React.FC<ScheduleContainerProps> = ({ content }) => {
  const { schedules, page, totalPage, handlePageChange, loading } =
    useSchedules(content.serviceId);

  return (
    <span id="schedule-section">
      <Collapsable heading={content.heading} isOpen={true}>
        <Box>
          {/* <ScheduleFilter /> */}
          <Schedules
            schedules={schedules}
            currentPage={page}
            totalPage={totalPage}
            handlePageChange={handlePageChange}
            loading={loading}
          />
        </Box>
      </Collapsable>
    </span>
  );
};

export default ScheduleContainer;
